import React from 'react';

const PostIcons = (props) => {
	const {
		icons,
	} = props;

	let iconsTag = <div className="cpt-post-icons">
		{
			icons.map((item, index) => {
				return (
					<div className='cpt-post-icons__item' key={index}>
						<span
							dangerouslySetInnerHTML={{ __html: item.icon }}
						>
						</span>
					</div>
				);
			})
		}
	</div>

	return iconsTag;
}

export default PostIcons;